import { styled } from 'stitches.config'

export const DogLoversRoot = styled('section', {
  backgroundColor: '$tertiary-200',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  padding: '2.81rem 0',
  position: 'relative',
  gap: '$3',
  '@bp2': {
    gap: '$5',
    paddingTop: '$7',
    '& p': {
      padding: '0 $10',
    },
  },
})

export const DogLoversTitle = styled('h2', {
  color: '$primary-500',
  zIndex: '1',
})

export const DogLoversBody = styled('p', {
  textAlign: 'center !important',
  zIndex: '1',
  textWrap: 'pretty',
})

export const DogLoversImage = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  position: 'relative',
  zIndex: '1',
  '& img': {
    display: 'block !important',
    width: '100% !important',
    height: 'auto !important',
    objectFit: 'cover !important',
  },
  '@bp2': {
    '& img': {
      width: 'auto',
      height: 'auto',
      objectFit: 'contain',
    },
  },
})

export const DogBlobLeft = styled('div', {
  position: 'absolute',
  width: 'auto',
  height: 'auto',
  left: '0',
  top: '10rem',
  zIndex: '0',
  display: 'none',
  '@bp3': {
    display: 'block',
  },
})

export const DogBlobRight = styled('div', {
  position: 'absolute',
  width: 'auto',
  height: 'auto',
  right: '0',
  bottom: '-2rem',
  zIndex: '0',
  display: 'none',
  '@bp3': {
    display: 'block',
  },
})
